<template>
  <div>
    <div v-if="openType === 0">
      <el-descriptions style="margin: 0 20px 20px 20px" :column="2" border>
        <el-descriptions-item>
          <template slot="label">姓名</template>
          {{addEditForm.name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">补贴项目</template>
          {{addEditForm.project}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">补贴金额</template>
          {{addEditForm.amount}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">发放时间</template>
          {{addEditForm.grantTime}}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div v-else>
      <el-form style="margin: 20px 40px 0 0" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="addEditForm.name" placeholder="输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="补贴项目" prop="project">
              <el-input v-model="addEditForm.project" placeholder="输入补贴项目"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="补贴金额" prop="amount">
              <el-input v-model="addEditForm.amount" placeholder="输入补贴金额"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发放时间" prop="grantTime">
              <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.grantTime"
                              type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="xxxx-xx-xx xx:xx:xx" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="height: 50px">
      <el-row v-if="openType !== 0" style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('addEditForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
      <el-row v-else style="margin: 0 20px">
        <div class="cancel-btn" style="float: right" @click="closeAddEdit()">
          <span>关闭</span>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import {createsubsidy, updatesubsidy} from '../../../api/yanglaoyuan/subsidyManage'

export default {
  name: 'addEditSubsidy',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    subsidyObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      eId: 0,
      espId: 0,
      espName: '',
      // 打开类型 0查看 1新增 2编辑
      openType: 0,
      row: '',
      pickerOptions: {},

      addEditForm: {
        name: '',
        project: '',
        amount: '',
        grantTime: ''
      },
      addEditRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        project: [{ required: true, message: '请输入补贴项目', trigger: 'blur' }],
        amount: [{required: true, message: '请选择补贴金额', trigger: 'change'}],
        grantTime: [{required: true, message: '请选择发放时间', trigger: 'change'}]
      }
    }
  },
  created () {
    this.getStartData()
  },
  methods: {
    getStartData () {
      let loginResp = this.$store.state.user.LoginResp
      this.eId = loginResp.entity_id
      this.espId = loginResp.syspersonid
      this.espName = loginResp.personname

      this.openType = this.subsidyObj.openType
      this.row = this.subsidyObj.row

      if (this.openType === 0) {
        this.addEditForm.name = this.row.name
        this.addEditForm.project = this.row.project
        this.addEditForm.amount = this.row.amount
        this.addEditForm.grantTime = this.row.grant_time
      } else if (this.openType === 2) {
        this.addEditForm.name = this.row.name
        this.addEditForm.project = this.row.project
        this.addEditForm.amount = this.row.amount
        this.addEditForm.grantTime = this.row.grant_time
      }
    },

    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.openType === 1) {
            this.sendAdd()
          } else if (this.openType === 2) {
            this.sendEdit()
          }
        }
      })
    },
    sendAdd () {
      let data = {
        e_id: this.eId,
        name: this.addEditForm.name,
        project: this.addEditForm.project,
        amount: this.addEditForm.amount,
        grant_time: this.addEditForm.grantTime
      }
      createsubsidy(data).then(res => {
        this.$notify({title: '成功', message: '成功新建补贴项目', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },
    sendEdit () {
      let data = {
        id: this.row.id,
        e_id: this.eId,
        name: this.addEditForm.name,
        project: this.addEditForm.project,
        amount: this.addEditForm.amount,
        grant_time: this.addEditForm.grantTime
      }
      updatesubsidy(data).then(res => {
        this.$notify({title: '成功', message: '成功修改补贴项目', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditSubsidy.vue